module.exports = __webpack_public_path__ + "img/goods7_1.8d6ce51c.jpg";